export { default } from "./ContactGroup";
